var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning"},[_c('b-img',{staticClass:"mr-2",attrs:{"blank":"","blank-color":"#ff7777","width":"12","height":"12"}}),_c('h3',[_vm._v(_vm._s(_vm.string))]),_c('h4',[_vm._v(_vm._s(_vm.explanation))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }